(function() {
    'use strict';

    angular.module('remitEventsApp').factory('Graph', function($resource, HelpersService) {
        return {
            decorateWithStyles: function(powerplants) {
                var that = this;
                _.each(powerplants, function(powerplant) {
                    that.decorateUnavailabilitiesWithStyles(powerplant.unavailabilities);
                    _.each(powerplant.blocks, function(block) {
                        that.decorateUnavailabilitiesWithStyles(block.unavailabilities);
                    });
                });
            },
            decorateUnavailabilitiesWithStyles: function(unavailabilities) {
                _.each(unavailabilities, function(unavailability) {
                    var notPlannedHeight = unavailability.notPlannedUnavailability / unavailability.installedCapacity;
                    var plannedHeight = unavailability.plannedUnavailability / unavailability.installedCapacity;
                    var sumHeight = notPlannedHeight + plannedHeight;
                    if (sumHeight > 1) {
                        notPlannedHeight = notPlannedHeight / sumHeight;
                        plannedHeight = plannedHeight / sumHeight;
                    }
                    unavailability.plannedStyle = {
                        'background-color': '#092D74',
                        width: '100%',
                        height: plannedHeight * 59 + 'px'
                    };
                    unavailability.notPlannedStyle = {
                        'background-color': '#E60007',
                        width: '100%',
                        height: notPlannedHeight * 59 + 'px'
                    };
                });
            },

            decorateWithVisibility: function(powerplants) {
                var groupId = 0;
                var showHeader = true;
                _.each(powerplants, function(powerplant) {
                    powerplant.visible = true;
                    powerplant.showHeader = showHeader;
                    showHeader = false;
                    groupId++;
                    powerplant.groupId = groupId;
                    _.each(powerplant.blocks, function(block) {
                        block.visible = false;
                        block.groupId = groupId;
                    });
                });
            },

            toggleBlocks: function(powerplants, groupId) {
                var showHeader = true;
                _.each(powerplants, function(powerplant) {
                    powerplant.showHeader = showHeader;
                    if (powerplant.groupId === groupId) {
                        var powerplantVisible = powerplant.visible;
                        powerplant.visible = !powerplant.visible;
                        _.each(powerplant.blocks, function(block) {
                            block.visible = powerplantVisible;
                        });
                    }
                    showHeader = !powerplant.visible;
                });
            },

            getWeeks: function(year) {
                var tmpDate = moment({
                    year: year,
                    month: 0,
                    day: 1
                }).startOf('week');
                var weeks = [];
                while (
                    tmpDate.isBefore(
                        moment({
                            year: year + 1
                        })
                    )
                ) {
                    var weekId = tmpDate.get('week');
                    var dayFrom = tmpDate.format('DD');
                    var weekEnd = tmpDate
                        .clone()
                        .add(1, 'weeks')
                        .add(-1, 'day');
                    var dayTo = weekEnd.format('DD');
                    var currentWeek = moment().isBetween(tmpDate, weekEnd);

                    weeks.push({
                        id: weekId,
                        currentWeek: currentWeek,
                        label: 'remitEventsApp.graph.granulation.weeks.' + tmpDate.format('MM') + weekEnd.format('MM'),
                        labelParams: {
                            id: weekId,
                            from: dayFrom,
                            to: dayTo
                        },
                        date: tmpDate.clone()
                    });

                    tmpDate.add(1, 'weeks');
                }

                return weeks;
            },

            getDecoratedTimestamps: function(timestamps, granulation) {
                if (granulation == 'YEAR') {
                    _.each(timestamps, function(timestamp) {
                        timestamp.label = 'remitEventsApp.graph.granulation.months.short.' + timestamp.label;
                    });
                }

                return timestamps;
            },
            setControlsScroll: function() {
                var $rigthScrollControl = HelpersService.findElement('.scroll-bar.right');
                var $leftScrollControl = HelpersService.findElement('.scroll-bar.left');
                var $tableNames = HelpersService.findElement('.table-with-names');

                if ($tableNames.element) {
                    $rigthScrollControl.height($tableNames.height() - 80);
                    $leftScrollControl.height($tableNames.height() - 80);
                }
            },
            setTablePosition: function() {
                var $tableDataScroll = HelpersService.findElement('.table-data-scroll');

                if (!$tableDataScroll.element) {
                    return;
                }

                var widthTable = $tableDataScroll.width() + HelpersService.findElement('.side-graph.left').width() + 30;
                var leftPosition = HelpersService.findElement('.powerplant-row').width() + 18;
                var widthContainer = HelpersService.findElement('.energy-table').width();
                var $rigthScrollControl = HelpersService.findElement('.scroll-bar.right');
                var $leftScrollControl = HelpersService.findElement('.scroll-bar.left');

                HelpersService.findElement('.side-graph.right').scrollLeft(widthTable - widthContainer);

                $leftScrollControl.css({
                    left: leftPosition + 'px'
                });

                if (widthTable < widthContainer) {
                    $rigthScrollControl
                        .css({
                            left:
                                HelpersService.findElement('.table-data-scroll table tr:first-child td:last-child').position().left +
                                HelpersService.findElement('.table-data-scroll table tr:first-child td:last-child').width() +
                                HelpersService.findElement('.side-graph.left').width() +
                                15
                        })
                        .addClass('disabled');
                    $leftScrollControl.addClass('disabled');
                } else {
                    $rigthScrollControl
                        .removeAttr('style')
                        .css({
                            right: '20px'
                        })
                        .removeClass('disabled');
                    $leftScrollControl.removeClass('disabled');
                }

                this.setControlsScroll();
            },
            getLastEventYear: function() {
                return $resource(
                    'api/events/lastEventYear',
                    {},
                    {
                        query: {
                            method: 'GET',
                            isArray: false
                        }
                    }
                );
            }
        };
    });
})();
